<div class="pageheader">
    <div class="page-title">
        <h1>Settings</h1>
        <div class="btn-toolbar">
            <button class="btn btn-link" (click)="refresh($event.shiftKey)">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Settings_Action_Settings_ShowLog'" [title]="'Settings log'">
                <app-change-log-link-entity type="Setting"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="row mt-2">
    <div class="col-sm-12">
        <dx-data-grid biz-grid [selection]='{ mode: "none" }' [showIsLoading]="isLoading" [dataSource]='allSettings.Rows' [bizAutoWidth]="false" [bizSetSummary]="false" [bizSetPager]="false"
            (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)" (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)"
            (onEditingStart)="onEditingStart($event)">

            <dxo-editing mode="popup" [allowAdding]="allowAdding" [allowUpdating]="allowUpdating" [allowDeleting]="allowDeleting">
            </dxo-editing>
            <dxo-grouping expandMode="rowClick"></dxo-grouping>

            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

            <dxi-column dataField="Category" caption="Category" [validationRules]="[{ type: 'required' }]" dataType="string" [groupIndex]="0" editCellTemplate="categoryEditTemplate"></dxi-column>
            <dxi-column dataField="Name" caption="Name" [validationRules]="[{ type: 'required' }]" dataType="string" sortOrder="asc"></dxi-column>
            <dxi-column dataField="Description" caption="Description" [validationRules]="[{ type: 'required' }]" dataType="string"></dxi-column>
            <dxi-column dataField="DataType" caption="Type" [validationRules]="[{ type: 'required' }]" dataType="string" visible="false" [setCellValue]="setCellValue">
                <dxo-lookup [dataSource]="dataTypes" valueExpr="id" displayExpr="display"></dxo-lookup>
            </dxi-column>

            @for (env of allSettings.Environments; track env; let i = $index) {
            <dxi-column dataField="Values[{{i}}]" [caption]="env ?? '(Default)'" cellTemplate="cellViewTemplate" editCellTemplate="cellEditTemplate"
                [calculateFilterExpression]="environmentValuesFilterExpressionFactory(i)">
                <dxo-header-filter [dataSource]="environmentValuesFilterData(i)" />
            </dxi-column>
            }

            <dxi-column type="buttons">
                <dxi-button name="edit"></dxi-button>
                <dxi-button name="delete"></dxi-button>
                <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog">
                </dxi-button>
            </dxi-column>

            <ng-container *dxTemplate="let cell of 'categoryEditTemplate'">
                <dx-select-box [dataSource]="allCategories" [acceptCustomValue]="true" [value]="cell.data.Category" (onCustomItemCreating)="addCustomCategory($event)"
                    (valueChange)="cell.setValue($event)"></dx-select-box>
            </ng-container>

            <ng-container *dxTemplate="let cell of 'logTemplate'">
                <app-change-log-link *bizPermissionRequired="'Settings_Action_Settings_ShowLog'" [title]="'Logs for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
                    <app-change-log-link-entity type="Setting" [id]="cell.data.SettingsId"></app-change-log-link-entity>
                </app-change-log-link>
            </ng-container>

            <ng-container *dxTemplate="let cell of 'cellViewTemplate'">
                @if (cell.data.DataType === 'Password') {
                    <span>{{cell.value.SecretId ? '••• A password is set •••' : ''}}</span>
                }
                @else {
                    <span>{{cell.value.Value}}</span>
                }
            </ng-container>

            <ng-container *dxTemplate="let cell of 'cellEditTemplate'">
                @if(cell.data.DataType === 'Password'){
                <app-password section="settings" [allowShowPassword]="allowShowPassword" [readonly]="false" [value]="{ id: cell.value.SecretId, value: cell.value.SecretValue }"
                    (valueChange)="onCellValueChange($event, cell)"></app-password>
                }
                @else {
                <dx-text-box [value]="cell.value.Value" (valueChange)="onCellValueChange($event, cell)"></dx-text-box>
                }
            </ng-container>
        </dx-data-grid>
    </div>
</div>
